import { render, staticRenderFns } from "./IncomeStatementDetailEditor.vue?vue&type=template&id=8ed03ae8&"
import script from "./IncomeStatementDetailEditor.vue?vue&type=script&lang=js&"
export * from "./IncomeStatementDetailEditor.vue?vue&type=script&lang=js&"
import style0 from "./IncomeStatementDetailEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports